export class VirtualDisplay {
    constructor(socket) {
        this.socket = socket;
        this.videoInput = '1';
        this.volume = 50;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'videoInput',
                regExp: /INPUT (\d+|\?)/i,
                callback: (match) => {
                    if (match[1] === '?') {
                        this.socket.send(this.videoInput);
                    }
                    else {
                        this.videoInput = match[1];
                        this.socket.send(`OK`);
                    }
                },
            },
            {
                name: 'volume',
                regExp: /VOLUME (\d+|\?)/i,
                callback: (match) => {
                    if (match[1] === '?') {
                        this.socket.send(this.volume.toString());
                    }
                    else {
                        const volume = parseInt(match[1], 10);
                        if (Number.isNaN(volume) || volume < 0 || volume > 100) {
                            this.socket.send(`ERR`);
                        }
                        else {
                            this.volume = volume;
                            this.socket.send(`OK`);
                        }
                    }
                },
            },
            {
                name: 'volumeMute',
                regExp: /MUTE (1|0|\?)/i,
                callback: (match) => {
                    if (match[1] === '?') {
                        this.socket.send(this.volumeMute ? '1' : '0');
                    }
                    else {
                        this.volumeMute = match[1] === '1';
                        this.socket.send(`OK`);
                    }
                },
            },
        ];
    }
}
VirtualDisplay.emulatorType = 'socketEmulator';
VirtualDisplay.key = '-N30OglJJ5KY5zaoIr4R';
